/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditEventType } from './audit-event-type';
import {
    AuditEventTypeFromJSON,
    AuditEventTypeFromJSONTyped,
    AuditEventTypeToJSON,
    AuditEventTypeToJSONTyped,
} from './audit-event-type';
import type { AuditScopeType } from './audit-scope-type';
import {
    AuditScopeTypeFromJSON,
    AuditScopeTypeFromJSONTyped,
    AuditScopeTypeToJSON,
    AuditScopeTypeToJSONTyped,
} from './audit-scope-type';

/**
 * A single audit log entry
 * @export
 * @interface AuditLogItem
 */
export interface AuditLogItem {
    /**
     * Unique identifier for the audit log entry
     * @type {string}
     * @memberof AuditLogItem
     */
    id: string;
    /**
     * When the event was processed
     * @type {Date}
     * @memberof AuditLogItem
     */
    eventTime: Date;
    /**
     * Original timestamp of the event
     * @type {Date}
     * @memberof AuditLogItem
     */
    originalEventTime: Date;
    /**
     * The scope type (e.g., CONVERSATION, TENANT)
     * @type {AuditScopeType}
     * @memberof AuditLogItem
     */
    scopeType: AuditScopeType;
    /**
     * ID of the scope entity (e.g., conversation ID)
     * @type {string}
     * @memberof AuditLogItem
     */
    scopeId?: string | null;
    /**
     * The type of audit event
     * @type {AuditEventType}
     * @memberof AuditLogItem
     */
    eventType: AuditEventType;
    /**
     * Human-readable description of the event
     * @type {string}
     * @memberof AuditLogItem
     */
    description?: string | null;
    /**
     * ID of the actor who performed the action
     * @type {string}
     * @memberof AuditLogItem
     */
    actorId?: string | null;
    /**
     * Additional event data in JSON format
     * @type {string}
     * @memberof AuditLogItem
     */
    data?: string | null;
}



/**
 * Check if a given object implements the AuditLogItem interface.
 */
export function instanceOfAuditLogItem(value: object): value is AuditLogItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('eventTime' in value) || value['eventTime'] === undefined) return false;
    if (!('originalEventTime' in value) || value['originalEventTime'] === undefined) return false;
    if (!('scopeType' in value) || value['scopeType'] === undefined) return false;
    if (!('eventType' in value) || value['eventType'] === undefined) return false;
    return true;
}

export function AuditLogItemFromJSON(json: any): AuditLogItem {
    return AuditLogItemFromJSONTyped(json, false);
}

export function AuditLogItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditLogItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'eventTime': (new Date(json['event_time'])),
        'originalEventTime': (new Date(json['original_event_time'])),
        'scopeType': AuditScopeTypeFromJSON(json['scope_type']),
        'scopeId': json['scope_id'] == null ? undefined : json['scope_id'],
        'eventType': AuditEventTypeFromJSON(json['event_type']),
        'description': json['description'] == null ? undefined : json['description'],
        'actorId': json['actor_id'] == null ? undefined : json['actor_id'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function AuditLogItemToJSON(json: any): AuditLogItem {
    return AuditLogItemToJSONTyped(json, false);
}

export function AuditLogItemToJSONTyped(value?: AuditLogItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'event_time': ((value['eventTime']).toISOString()),
        'original_event_time': ((value['originalEventTime']).toISOString()),
        'scope_type': AuditScopeTypeToJSON(value['scopeType']),
        'scope_id': value['scopeId'],
        'event_type': AuditEventTypeToJSON(value['eventType']),
        'description': value['description'],
        'actor_id': value['actorId'],
        'data': value['data'],
    };
}

